module.exports = __webpack_public_path__ + "static/img/VCG211377914193.58bed40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/VCG211377914193.jpg
// module id = HXs4
// module chunks = 52